// extracted by mini-css-extract-plugin
export var actions = "bQ_fz";
export var articleMultipleChoiceCTA = "bQ_fN";
export var body = "bQ_fQ";
export var bodyContainer = "bQ_fP";
export var illustration = "bQ_fS";
export var selected = "bQ_fW";
export var subtitle = "bQ_fV";
export var textContent = "bQ_fT";
export var tile = "bQ_fR";
export var wrapper = "bQ_b5";